<template>
  <AppLayout>
    <template #middle>
      <InnerContent>
        <DashboardContent />
      </InnerContent>
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import { watch } from 'vue'

import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import usePlatformSetupStatus from '@/features/admin/platform-setup/hooks/use-platform-setup-status.hook'
import InnerContent from '@/features/ui/components/inner-content/inner-content.vue'
import DashboardContent from '@/features/ui/pages/admin/dashboard/dashboard-content/dashboard-content.vue'
import useRouter from '@/hooks/use-router.hook'
import { ROUTES } from '@/utils/config/constants'

const router = useRouter()
const { shouldOpenWizardRef } = usePlatformSetupStatus()

// Plateforme neuve : le premier admin qui arrive ici est envoyé sur l'assistant de mise en route.
watch(
  shouldOpenWizardRef,
  (shouldOpen) => {
    if (shouldOpen) router?.replace(ROUTES.ADMIN.SETUP).catch(() => {})
  },
  { immediate: true },
)
</script>
